var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnfi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.969 11.808v5.68l6.883 6.628h5.418l-4.331 4.25H8.9l-5.18-5.02v-7.21l4.249-4.328zm.083-3.924h-.17L1 14.853v9.518l6.884 6.63h9.348l6.8-6.629v-.254h.17L31 17.487V7.97L24.2.999h-9.347l-6.8 6.884zm2.635 2.974v5.603l5.182 5.022h5.187v-5.346l-5.118-5.278h-5.252zm13.343 9.521v-5.527l-6.798-6.97h-5.2l3.838-3.908h7.037l5.118 5.277v7.21l-3.994 3.917z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfi);
export default __webpack_public_path__ + "static/media/UNFI.b916d304f0a25d2971d2722d862c7ff6.svg";
export { ForwardRef as ReactComponent };